export const CLAIM_AIRLINE = 'https://nexa/airline' as const;
export const CLAIM_ROLE = 'https://nexa/role' as const;
export const CLAIM_OPERATOR_URN = 'https://nexa/operator_urn' as const;
export const CLAIM_SERVICE_URN = 'https://nexa/service_urn' as const;
export const CLAIM_SCOPE = 'https://nexa/scope' as const;

export const NEXA_CLAIM_NAMESPACE = 'https://nexa/' as const;

export type NexaClaimKey =
  | typeof CLAIM_AIRLINE
  | typeof CLAIM_ROLE
  | typeof CLAIM_OPERATOR_URN
  | typeof CLAIM_SERVICE_URN
  | typeof CLAIM_SCOPE;

// --- Per-operator work scope (auth:X-Operator-Context@v2, NEX-309) ----------
//
// FROZEN against `packages/airport-reference` `Scope` / `ScopeKind`. Redeclared
// here as an identical *structural* type rather than imported, to avoid a
// runtime dependency cycle (@nexa/auth must stay browser-safe and must not pull
// the airport catalog). If airport-reference's `Scope` shape changes, this MUST
// change in lockstep — the vocabulary is closed: REGION|COUNTRY|AIRPORT|ALL.

/** Closed scope vocabulary — matches airport-reference `ScopeKind` exactly. */
export const SCOPE_KINDS = ['REGION', 'COUNTRY', 'AIRPORT', 'ALL'] as const;

/** Scope kinds that can be expanded to a concrete IATA set (frozen). */
export type AuthScopeKind = (typeof SCOPE_KINDS)[number];

/**
 * A single operator work-scope. `code` is required for every kind except
 * `ALL` (where it is ignored / may be omitted):
 *   - `REGION`  → a region code (e.g. `'BR'`)
 *   - `COUNTRY` → an ISO 3166-1 alpha-3 code (e.g. `'BRA'`)
 *   - `AIRPORT` → an IATA code (e.g. `'GRU'`)
 *   - `ALL`     → everything (no `code`)
 */
export interface AuthScope {
  kind: AuthScopeKind;
  code?: string;
}
